import { FeatureKey, Roles } from './../../../_models/feature';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { BusinessServices } from 'src/app/kuba/businesses/services/business.services';
import { forkJoin, Observable } from 'rxjs';
import { Department } from '../../deviation/models/deviationDepartment';
import { DeviationList } from '../../deviation/models/deviationList';
import { BaseServices } from './../../kuba.services';
import {
  Business,
  Client,
  FollowupPerson,
  ResponsibleForExe,
  Topic,
  TypeOfCase,
  UserRole
} from './../models/deviation';
import { DeviationServices } from './deviation.services';
import { BusinessDepartmentService } from './../../business-department.services';
import { RiskanalysisService } from './risk-analysis.service';
import { ModuleObjectDropdownOptionDto } from '../models/moduleObjectDropdown';

@Injectable()
export class FollowupDeviationListResolver {
  constructor(private backend: DeviationServices) {}
  resolve(route: ActivatedRouteSnapshot): Observable<DeviationList[]> {
    if (+BaseServices.roleId === UserRole.PORTAL) {
      return this.backend.getDeviationByPortal(BaseServices.PortalId);
    } else if (+BaseServices.roleId === UserRole.ADMIN) {
      return this.backend.getDeviationByAdmin(BaseServices.ApplicationId);
    } else {
      return this.backend.getDeviationByBusiness(BaseServices.BusinessId);
    }
  }
}
@Injectable()
export class AllDepartmentCachedResolver {
  constructor(private backend: BusinessDepartmentService) {}
  resolve(route: ActivatedRouteSnapshot): Observable<Department[]> {
    return this.backend.getCachedBusinessDepartment();
  }
}
@Injectable()
export class AllDepartmentResolver {
  constructor(
    private backend: DeviationServices,
    private businessDepartmentService: BusinessDepartmentService
  ) {}
  resolve(route: ActivatedRouteSnapshot): Observable<Department[]> {
    // Skip fetching for admin level on routes that explicitly opt out
    const skipAdmin = route.data && route.data['skipAdminPreloads'] === true;
    if (skipAdmin && BaseServices.roleId === '1') {
      // Return empty observable so component can proceed without preloaded departments
      return null as any;
    }
    return this.businessDepartmentService.getCachedBusinessDepartment();
  }
}
@Injectable()
export class FollowupCaseTypeResolver {
  constructor(private backend: DeviationServices) {}
  resolve(route: ActivatedRouteSnapshot): Observable<TypeOfCase[]> {
    return this.backend.getAllCaseType();
  }
}
@Injectable()
export class FollowupTopicResolver {
  constructor(private backend: DeviationServices) {}
  resolve(route: ActivatedRouteSnapshot): Observable<Topic[]> {
    const allowedRoles = [UserRole.EDITOR, UserRole.USER, UserRole.GUEST];
    if (allowedRoles.includes(+BaseServices.roleId)) {
      return this.backend.getAllTopics(BaseServices.BusinessId);
    } else {
      return null;
    }
  }
}
@Injectable()
export class ResponsibleForExecutionResolver
{
  constructor(private backend: DeviationServices) {}
  resolve(route: ActivatedRouteSnapshot): Observable<ResponsibleForExe[]> {
    return this.backend.getUser(BaseServices.BusinessId);
  }
}
@Injectable()
export class BusinessResolver {
  constructor(private backend: DeviationServices) {}
  resolve(route: ActivatedRouteSnapshot): Observable<Business[]> {
    return this.backend.getBusiness();
  }
}
@Injectable()
export class ClientResolver {
  constructor(private backend: DeviationServices) {}
  resolve(route: ActivatedRouteSnapshot): Observable<Client[]> {
    const allowedRoles = [UserRole.EDITOR, UserRole.USER, UserRole.GUEST];
    if (allowedRoles.includes(+BaseServices.roleId)) {
      return this.backend.getClients(BaseServices.BusinessId);
    } else {
      return null;
    }
  }
}
@Injectable()
export class DeviationsByUserResolver {
  constructor(private backend: DeviationServices) {}
  resolve(route: ActivatedRouteSnapshot): Observable<FollowupPerson[]> {
    return this.backend.getDeviationsByUser(BaseServices.UserId);
  }
}
@Injectable()
export class EmployeeContactsListResolver
{
  constructor(private backend: BusinessServices) {}
  resolve(route: ActivatedRouteSnapshot): Observable<ResponsibleForExe[]> {
    let businessId = route.queryParams['Id'];
    if (Number(BaseServices.roleId) === Roles.PORTAL && businessId) {
      return this.backend.getHseManager(parseInt(businessId));
    } else {
      return this.backend.getHseManager(BaseServices.BusinessId);
    }
  }
}
@Injectable()
export class DeviationUserResolver {
  constructor(private backend: DeviationServices) {}
  resolve(route: ActivatedRouteSnapshot): Observable<ResponsibleForExe[]> {
    let businessId = route.queryParams['Id'];
    if (Number(BaseServices.roleId) === Roles.ADMIN) {
      return null;
    } else if (Number(BaseServices.roleId) === Roles.PORTAL && businessId) {
      return this.backend.getUser(parseInt(businessId));
    } else {
      return this.backend.getUser(BaseServices.BusinessId);
    }
  }
}

@Injectable()
export class DepartmentsByBusinessIdResolver {
  constructor(private backend: BusinessDepartmentService) {}
  resolve(route: ActivatedRouteSnapshot): Observable<Department[]> {
    let businessId = route.queryParams['Id'];
    return this.backend.getDepartmentsByBusinessId(businessId) as Observable<
      Department[]
    >;
  }
}

@Injectable()
export class BusinessLevelTopicResolver {
  constructor(private backend: RiskanalysisService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<Topic[]> {
    let businessId = route.queryParams['Id'];
    return this.backend.getTopicByBusinessIdForPortal(
      parseInt(businessId)
    ) as Observable<Topic[]>;
  }
}

@Injectable()
export class FollowupCaseTypeByBusinessIdResolver
{
  constructor(private backend: DeviationServices) {}
  resolve(route: ActivatedRouteSnapshot): Observable<TypeOfCase[]> {
    return this.backend.getAllCaseTypeByBusinessId(
      parseInt(route.queryParams['Id'])
    );
  }
}

@Injectable()
export class ModuleObjectDropdownResolver
{
  constructor(private backend: DeviationServices) {}
  resolve(): Observable<ModuleObjectDropdownOptionDto[]> {
    return this.backend.getModuleDropdown(
      BaseServices.BusinessId
    ) as Observable<ModuleObjectDropdownOptionDto[]>;
  }
}
